import React from 'react'
import Icon from '../../../../components/Icon'
import { confirm } from '../../../../components/Dialog'
import Axios from 'axios'
import { useAuth } from '@polvo-labs/react-auth'
import { toast } from 'react-toastify'
import UserType from '../../../../models/User'

interface Props {
  user: UserType
  afterDelete: () => void

}

const DeleteUser: React.FC<Props> = ({ user, afterDelete }) => {

  const { token } = useAuth()

  return (
    <div>
      <button
        onClick={(evt?: any) => {
          evt.stopPropagation()
          confirm({
            title: 'Confirme',
            message: 'Tem certeza de que deseja excluir o usuário ' + user.name + '?',
            buttons: [
              {
                label: 'Sim',
                onClick: () => {
                  Axios({
                    method: 'DELETE',
                    url: `${process.env.REACT_APP_API_URL}/users/${user.id}`,
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }).then(({ data }) => {
                    toast.success('Usuário excluído com sucesso.')
                    afterDelete()
                  }).catch(() => {
                  })
                },
              },
              {
                label: 'Não',
                onClick: () => { },
              },
            ],
          })
        }}
      >
        <Icon
          name="delete"
        />
      </button>
    </div>
  )
}

export default DeleteUser
